/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect, useState, useCallback } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Button, Card, Empty, Tabs } from "antd";
import { Edit2, Setting2 } from "iconsax-react";

import Meta from "antd/lib/card/Meta";

import PageHeader from "../../../components/PageHeader";
import { useProfiles } from "../../../hooks/profile";
import useAdminGuard from "../../../hooks/useAdminGuard";

import {
  DataTypeActivity,
  DataTypeVideo,
  useModulos,
} from "../../../hooks/module";
import { useAuth } from "../../../hooks/auth";

import { Container, Main } from "./styles";
import Footer from "../../../components/Footer";
import Breadcrumb from "../../../components/Breadcrumb";

type ModuleDetailsState = {
  id: string;
  title?: string;
  tumblr?: string;
  description?: string;
  dados?: string;
};

function ModuleDetails() {
  useAdminGuard();

  const { getAll } = useProfiles();
  const navigate = useNavigate();
  const { getVideos, getActivities } = useModulos();
  const { TabPane } = Tabs;
  const { state } = useLocation() as { state?: ModuleDetailsState };
  const [dataSnapshot, setDataSnapshot] = useState<DataTypeVideo[]>([]);
  const [activities, setActivities] = useState<DataTypeActivity[]>([]);

  const { user } = useAuth();
  const isAdmin = user?.type === "admin" || user?.isAdmin;

  const loadModuleContent = useCallback(async () => {
    if (!state?.id) return;
    const [videos, acts] = await Promise.all([
      getVideos(state.id),
      getActivities(state.id),
    ]);
    setDataSnapshot(videos);
    setActivities(acts);
  }, [getVideos, getActivities, state?.id]);

  useEffect(() => {
    loadModuleContent();
    async function loadData() {
      if (!user?.uid) return;
      try {
        await getAll(user.uid);
      } catch (error) {
        console.error("Failed to load user profile:", error);
        navigate("/");
      }
    }
    loadData();
  }, [getAll, navigate, loadModuleContent, user?.uid]);

  if (!state?.id) {
    return (
      <Container id="page-profile-form" className="container">
        <PageHeader title="Módulo" type="manager" />
        <Main>
          <Empty description="Módulo não encontrado" />
          <Button type="primary" onClick={() => navigate("/modules")}>
            Voltar aos módulos
          </Button>
        </Main>
        <Footer />
      </Container>
    );
  }

  return (
    <Container id="page-profile-form" className="container">
      <PageHeader
        title={`Modulo: ${state.title || "Detalhes"}`}
        description={state.description}
        type="manager"
      />
      <Main style={{ background: "none" }}>
        <Breadcrumb
          items={[
            { label: "Gerenciamento", link: "/manager" },
            { label: "Gerenciamento de Módulos", link: "/modules" },
            { label: state.title || "Detalhes do Módulo", active: true },
          ]}
        />
        <p>{state.dados}</p>
        <Tabs defaultActiveKey="1">
          <TabPane tab="Vídeos cadastrados no módulo" key="1">
            <div className="boxList">
              <div
                className="add"
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  gap: 12,
                  flexWrap: "wrap",
                }}
              >
                <h3>Videos do módulo</h3>
                {isAdmin && (
                  <Button
                    type="primary"
                    onClick={() =>
                      navigate(`/new-video/`, { state: { id: state.id } })
                    }
                  >
                    + Adicionar novo ítem
                  </Button>
                )}
              </div>
              {dataSnapshot.length === 0 && (
                <Empty description="Nenhum vídeo cadastrado" />
              )}
              {dataSnapshot.map((d) => (
                <div className="teste" key={d.uid}>
                  <Card
                    actions={[
                      <Setting2 key="setting" size={18} />,
                      <Edit2 key="edit" size={18} />,
                    ]}
                    style={{ margin: "10px 5px" }}
                    cover={
                      <iframe
                        src={d.link}
                        title="A"
                        allowFullScreen
                        style={{ border: "none", padding: 30 }}
                      />
                    }
                  >
                    <Meta title={d.title} />
                  </Card>
                </div>
              ))}
              <span style={{ width: "270px" }} />
            </div>
          </TabPane>
          <TabPane tab="Atividades cadastradas no módulo" key="2">
            <div className="boxList">
              <div
                className="add"
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  gap: 12,
                  flexWrap: "wrap",
                }}
              >
                <h3>Atividades do módulo</h3>
                {isAdmin && (
                  <Button
                    type="primary"
                    onClick={() =>
                      navigate(`/AtvForm/`, { state: { uid: state.id } })
                    }
                  >
                    + Adicionar nova atividade
                  </Button>
                )}
              </div>
              {activities.length === 0 ? (
                <Empty description="Não há atividades cadastradas no módulo" />
              ) : (
                activities.map((activity) => (
                  <Card
                    key={activity.uid}
                    style={{ margin: "10px 0", width: "100%" }}
                  >
                    <Meta
                      title={`Atividade ${activity.uid.slice(0, 8)}`}
                      description={`${activity.multipleChoice.length} questão(ões)`}
                    />
                    <ul style={{ marginTop: 12, paddingLeft: 18 }}>
                      {activity.multipleChoice.map((q) => (
                        <li
                          key={`${activity.uid}-${q.optionOne}-${q.correctOption}`}
                        >
                          Questão: correta = {q.correctOption}
                        </li>
                      ))}
                    </ul>
                  </Card>
                ))
              )}
            </div>
          </TabPane>
        </Tabs>
      </Main>
      <Footer />
    </Container>
  );
}

export default ModuleDetails;
